export default __webpack_public_path__ + "static/media/ep.21984161.png";